import { SET_PARTNERS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_PARTNERS_SETTINGS, {
  pageSize: 10,
  currentPageNum: 0,
  status: 'ALL',
  search: ''
})
